interface AccountingReportLogEntry {
  id?: number;
  companyId?: number;
  userId?: number;
  username?: string;
  obs?: string;
  reportUrl?: string;
  status?: string;
  createdAt?: string;
  reportType?: string;
}

export const newAccountingReportEntry = (): AccountingReportLogEntry => {
  return {};
};

export interface StatusData {
  class: string;
  name: string;
}

interface StatusesMap {
  [index: string]: StatusData;
}

export const ACCOUNTINGREPORTSSTATUSES: StatusesMap = {
  generating: {
    class: "primary",
    name: "Generando...",
  },
  completed: {
    class: "success",
    name: "Completado",
  },
  failed: {
    class: "danger",
    name: "Fallido",
  },
};

export const ACCOUNTINGREPORTSTYPES: StatusesMap = {
  sales: {
    class: "success",
    name: "Libro de Ventas (RG90)",
  },
  purchases: {
    class: "success",
    name: "Libro de Compras (RG90)",
  },
  journal: {
    class: "success",
    name: "Libro Diario",
  },
  ledger: {
    class: "success",
    name: "Libro Mayor",
  },
  inventory: {
    class: "success",
    name: "Inventario",
  },
  balance: {
    class: "success",
    name: "Balance General",
  },
  results: {
    class: "success",
    name: "Estado de Resultados",
  },
};

export const getAccountingReportLogStatusLabel = (key: string) => {
  return ACCOUNTINGREPORTSSTATUSES[key].name;
};

export const getccountingReportLogStatusClass = (key: string) => {
  return ACCOUNTINGREPORTSSTATUSES[key].class;
};

export const getAccountingReportLogTypeLabel = (key: string) => {
  return ACCOUNTINGREPORTSTYPES[key].name;
};

export default AccountingReportLogEntry;
